import whenDomReady from 'when-dom-ready';
import objectFitImages from 'object-fit-images';

import { LoadMore } from '@gebruederheitz/wp-async-posts-loader';
import './vendor/skip-link-focus-fix';
import { infoBox } from './frontend/infoBox';
import { navDropdown } from './frontend/navDropdown';
import { navSmallscreen } from './frontend/navSmallscreen';
import { toggleSearch } from './frontend/toggleSearch';
import { stageVideo } from './frontend/stageVideo';
import { testimonialSlider } from './frontend/testimonialSlider';
import { pageLinks } from './frontend/pageLinks';
import { slideshows } from './frontend/slideshows';

whenDomReady(() => {
    objectFitImages();
    infoBox();
    navDropdown();
    navSmallscreen();
    toggleSearch();
    stageVideo();
    testimonialSlider();
    pageLinks();
    slideshows();
    // Load more posts asynchronously */
    new LoadMore({
        containerSelector: '.sp-recent-posts',
    });
});
